import { useState } from 'react'
import style from './login.module.css'
import { registrarDiretorCompleto } from '../../../firebase/CRUD'
import { useNavigate } from 'react-router-dom'
import { 
   CheckCircle2, ArrowLeft, ChevronRight, 
  School
} from 'lucide-react';
import InputForm from '../../Forms/InputForm';
import { useToast } from '../../../hooks/Toast';
import CardAssinatura from '../../layout/CardAssinatura/CardAssinatura';

import { getFunctions,httpsCallable } from 'firebase/functions';
import { auth } from '../../../firebase/firebase';
import { planos } from '../../../stripePlanos';


function SiderBar({texto,passo}){
  return(
    <div className={`${style.sidebar}`}>
          <div>
            <div style={
                { 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '12px' 
                }}>
              <div style={{ background: 'white', color: '#2563eb', padding: '10px', borderRadius: '12px' }}>
                <School size={28} />
              </div>
              <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: 0 }}>EBD Chamada</h2>
            </div>
            
            <div className={`${style.marketing_text}`}>
              <h1 style={{ fontSize: '32px', fontWeight: '800', lineHeight: 1.2, marginBottom: '16px' }}>
                Transforme a gestão da sua EBD.
              </h1>
              <p style={{ fontSize: '16px', color: '#bfdbfe', lineHeight: 1.5 }}>
               {texto}
              </p>
            </div>
          </div>

          <div style={{ marginTop: '40px' }}>
            <div className={`${style.stepper}`}>
              <div className={`${style.step_dot} active`} />
              <div className={`${style.step_dot}`} />
              <div className={`${style.step_dot}`} />
            </div>
            <p style={{ fontSize: '13px', color: '#bfdbfe', margin: 0, fontWeight: 500 }}>
              {passo}
            </p>
          </div>
      </div>
  )
}

export default function FormCadastro({avancarPara}){
    const [isSaving, setIsSaving] = useState(false);

    const [formData, setFormData] = useState({ 
        igreja: '', 
        nome: '', 
        telefone: '', 
        email: '', 
        senha: '' 
    });
    const navigate = useNavigate()

    const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ 
      ...prev, 
      [name]: value 
        }));
    };

    // 3. Função que será chamada ao clicar em "Continuar"
    
    const guardarForm = async ({info})=>{
        setIsSaving(true)
        const diretor = {
            ...info,
            genero:'',
            nascimento: Date(),
            turma: '',
            turmaNome:'Professores',
            
            oferta: false,
            biblia: false,
            revista: false,
            presencas: 0,
            pontos: 0,
            historico:{
                biblias:[0,0,0,0],
                revistas:[0,0,0,0],
                presencas:[0,0,0,0],
                pontos:[0,0,0,0]
            }
        }
        // CORREÇÃO: importava/chamava `registarDiretorEscola`, que não
        // existe em CRUD.js (só existe `registrarDiretorCompleto`) — o
        // cadastro de uma escola nova quebrava aqui com TypeError antes
        // mesmo de criar a conta no Auth.
        
        const {idEscola} = await registrarDiretorCompleto(diretor,info.email,info.senha,info.igreja);
        avancarPara({diretor:diretor,igreja:info.igreja,idEscola:idEscola}); 
    }
    const FormOnSubmit=(e)=>{
      e.preventDefault()
      guardarForm({info:formData})
    }
    return(
      <div className={`${style.page_container}`}>
      {/* Injeta os estilos na página */}
     
      <div className={`${style.card_cadastro}`}>
        
        {/* LADO AZUL (Sidebar) */}
        <SiderBar 
          texto={"Crie a sua conta e teste gratuitamente o sistema completo de chamadas e relatórios."}
          passo={"Passo 1 de 3: Dados da Escola"}
        />

        {/* LADO BRANCO (Formulário) */}
        <div className={`${style.content_area}`}>
          <form className={`${style.form_container}`} onSubmit={FormOnSubmit}>
            
            <div className={`${style.form_header}`}>
              <h2 className={`${style.form_title}`}>Crie a sua conta</h2>
              <p className={`${style.form_subtitle}`}>Preencha os dados do diretor e da congregação.</p>
            </div>

             <InputForm 
                labelText={"Congregação"}
                Change={handleInputChange}
                name={"igreja"}
                minLength={"2"}
                placeholder={"Nome da congregação"}
                type={"text"}
                value={formData.igreja}
            />
            {/* Campo: Nome do Diretor */}
            <InputForm 
                labelText={"Nome do Diretor(a)"}
                Change={handleInputChange}
                name={"nome"}
                minLength={"2"}
                placeholder={"Seu nome completo"}
                type={"text"}
                value={formData.nome}
            />
            {/* Campo: Telefone */}
            
            <InputForm 
                labelText={"Telefone / WhatsApp"}
                Change={handleInputChange}
                name={"telefone"}
                minLength={"11"}
                placeholder={"(00) 00000-0000"}
                type={"tel"}
                value={formData.telefone}
                
            />
            <div className={`${style.input_row}`}>
                <InputForm 
                    labelText={"E-mail de acesso"}
                    Change={handleInputChange}
                    name={"email"}
                    minLength={"0"}
                    placeholder={"Digite seu E-mail"}
                    type={"email"}
                    value={formData.email}
                    
                />
                <InputForm 
                    labelText={"Senha"}
                    Change={handleInputChange}
                    name={"senha"}
                    minLength={"6"}
                    placeholder={"*********"}
                    type={"password"}
                    value={formData.senha}
                />
            </div>

            <button type="submit" className={`${style.btn_primary}`}>
              
              {isSaving ? (
                <div className={`${style.spinner}`} />
              ) : (
                <>
                  Continuar <ChevronRight size={20} />
                </>
              )}
            </button>

          </form>
        </div>
      </div>
    </div>
    )
}
// planos foi extraído para src/stripePlanos.js — reaproveitado também na
// página de gerenciamento de assinatura do ADM (PaginaUsuario.js).
export function CadastroForm2({nomeDiretor, voltar, avancarParaPagamento}) {
  
  const {mostrarAviso} = useToast()
  // 1. Estado para guardar qual o plano clicado
  const [planoSelecionado, setPlanoSelecionado] = useState({
     id: '',
      nome: '', 
      limite: '', 
      preco: '' 
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

 

  // 3. Ação de Continuar
  const handleContinuar = () => {
    
    setIsSubmitting(true);
    
    // Simula a transição
    setTimeout(() => {
      setIsSubmitting(false);
      
      if (planoSelecionado){
        mostrarAviso(`Plano Pago (${planoSelecionado.nome}) escolhido! Avançando para o Passo 3 (Pagamento).`,"sucesso");
        avancarParaPagamento(planoSelecionado)
      }
    }, 700);
  };
  return (
    <div className={`${style.page_container}`}>
      <div className={`${style.card_cadastro}`}>
        
        {/* LADO AZUL (Sidebar) */}
        <SiderBar 
          texto={"O crescimento da sua escola merece uma ferramenta à altura. Escolha como quer começar."}
          passo={"Passo 2 de 3: Escolha do Plano"}
        />
        {/* LADO BRANCO (Conteúdo) */}
        <div className={`${style.content_area}`}>
          <div className={`${style.form_container}`}>
            
            <button type="button" className={`${style.btn_back}`} onClick={() => voltar()}>
              <ArrowLeft size={18} /> Voltar para os meus dados
            </button>

            <div className={`${style.form_header}`}>
              <h2 className={`${style.form_title}`}>Olá, {nomeDiretor}!</h2>
              <p className={`${style.form_subtitle}`}>Selecione o plano de pagamento</p>
            </div>

            {/* A Grelha de Cartões de Planos */}
            <div className={`${style.planos_grid}`}>
              {planos.map((plano) => (
                <>
                <div 
                  key={plano.id} 
                  className={planoSelecionado.id === plano.id ? `${style.plano_card_selected}`:`${style.plano_card}`} 
                  onClick={() => setPlanoSelecionado(plano)}
                >
                  <CheckCircle2 size={24} className={`${style.check_icon}`} />
                  <span className={`${style.plano_nome}`}>{plano.nome}</span>
                  <div className={`${style.plano_preco}`}>
                    R$ {plano.preco} <span>{plano.limite}</span>
                  </div>
                </div>
                </>
              ))}
            </div>

            <button 
              type="button" 
              className={`${style.btn_primary}`} 
              onClick={handleContinuar}
              disabled={!planoSelecionado || isSubmitting}
            >
              {isSubmitting ? (
                <div className={`${style.spinner}`} />
              ) : (
                <>
                  {/* Se for gratuito não há pagamento, o botão diz Concluir */}
                  {planoSelecionado.nome === 'gratuito' ? 'Concluir Registo' : 'Ir para Pagamento'} 
                  <ChevronRight size={20} />
                </>
              )}
            </button>

          </div>
        </div>
      </div>
    </div>
  );
}

export function CadastroForm3({planoEscolhido, dadosCadastro, voltar}) {
  const navigate = useNavigate()
  const {mostrarAviso} = useToast()
 
  const [isProcessingPay, setIsProcessingPay] = useState(false);

  const handleProcessarPagamento = async () => {
    setIsProcessingPay(true);
    const functions = getFunctions();
    const createSession = httpsCallable(functions, 'createCheckoutSession');
    console.log( "priceId: ", planoEscolhido.precoId,
        "\n idEscola:", dadosCadastro.idEscola,
        "\n planoId:", planoEscolhido.id)
    try {
      const result = await createSession({ 
        priceId: planoEscolhido.precoId,
        idEscola: dadosCadastro.idEscola,
        planoId: planoEscolhido.id
      });
     
      // Redireciona para o Stripe
      window.location.href = result.data.url;
    } catch (error) {
      // CORREÇÃO: antes só logava no console — o usuário via a tela
      // travada, sem nenhuma explicação do que deu errado (foi assim que
      // a falha de autenticação relatada passou despercebida). Agora
      // mostra um aviso visível e distingue o caso mais comum
      // (sessão expirada/ausente) de outros erros.
      console.error("Erro ao iniciar pagamento:", error);
      if (error.code === 'functions/unauthenticated') {
        mostrarAviso('Sua sessão expirou. Faça login novamente para continuar o pagamento.', 'erro');
      } else {
        mostrarAviso('Não foi possível iniciar o pagamento: ' + error.message, 'erro');
      }
      setIsProcessingPay(false);
    }
};

 
  return (
    <div className={`${style.page_container}`}>
      {/* Injeta os estilos na página */}
     
      <div className={`${style.card_cadastro}`}>
        
        
        {/* LADO AZUL (Sidebar) */}
        
         <SiderBar 
            texto={"Finalize a sua assinatura de forma segura para libertar o acesso total à plataforma."}
            passo={"Passo 3 de 3: Pagamento Seguro"}
          />
        {/* LADO BRANCO (Conteúdo) */}
        <div className={`${style.content_area}`}>
          <CardAssinatura processarAssinatura={handleProcessarPagamento} email={dadosCadastro.diretor.email} plano={planoEscolhido}/>
        </div>
      </div>
    </div>
  );
}